export default {
  totalsBalanceChannels: [
    {
      channel: 'email',
      currentBalance: 0,
    },
    {
      channel: 'sms',
      currentBalance: 0,
    },
  ],
  totalsBalanceChannelsOrigin: [
    {
      channel: 'email',
      currentBalance: 0,
    },
    {
      channel: 'sms',
      currentBalance: 0,
    },
  ],
  balance: {},
  balanceOrigin: {},
}
